import './index.sass';
import './contest-item/index.sass';
import axios from "axios";
import { loadNew } from '~/blocks/grid';

export default () => {
    const $root = $('.contests-page');
    const $btn = $('.js-load-contest');

    $btn.on('click', function (e) {
        e.preventDefault();
        const $el = $(this);
        initAjax($el);
    });

    const initAjax = ($el) => {
        if(!$el.data('url')) $el.hide();
        $root.find('.contests-page__list').append('<div class="list-loader"></div>');
        axios.get($el.data('url'), {
            headers: { 'Accept': 'application/json' }
        }).then((response) => {
            const resp = response;
            const $contests = $(resp.data.items);
            const url = resp.data.url;
            if(url) {
            $el.data('url', url);
            } else {
            $el.remove();
            }
            $contests.addClass('grid-hidden');
            $root.find('.js-grid-container').append($contests);
            loadNew($contests);
            $root.find('.list-loader').remove();
            if(resp.data.pagination) {
            $root.find('.contests-page__pagination').html(resp.data.pagination);
            }
        }).catch((error) => {
            console.log(error.response)
        });
    }

    $(".js-contest-work-popup").on("click", function(e) {
        var itemUrl;
        e.preventDefault();
        itemUrl = $(this).data('url');
        return $.ajax({
            url: itemUrl,
            success: function(data) {
                var commentsSectionHeight;
                if (data.html) {
                    $('body').css('overflow', 'hidden');
                    $('#modal-container').html(data.html);
                    commentsSectionHeight = $('.modal-contest-work').find('.comments-wrp').outerHeight() - $('.modal-contest-work').find('.author-wrp').outerHeight() - $('.modal-contest-work').find('.comments-header').outerHeight() - $('.modal-contest-work').find('#comment_form_main').outerHeight();
                    $('#comments-section').css('max-height', commentsSectionHeight);
                    if (data.href) {
                        return history.replaceState({}, {}, data.href);
                    }
                }
            }
        });
    });
}
